import React from "react";
import { Box, Typography, IconButton } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import GridViewOutlinedIcon from "@mui/icons-material/GridViewOutlined";
import { ReactComponent as SettingsIcon } from "assets/images/icons/icn_btn_settings.svg";
import { ReactComponent as StartIcon } from "assets/images/icons/icn_btn_start.svg";

/**
 * ViewItem
 * Renders a single view row in the ResourceSidebar list.
 *
 * Props:
 *   view        - { id, name, layout, cameras[] }
 *   onEdit      - called with view when the settings icon is clicked
 *   onPlay      - called with view when the play icon is clicked
 */
const ViewItem = ({ view, onEdit, onPlay }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        mt: "8px",
        mb: "4px",
        px: "4px",
        py: "2px",
        backgroundColor: theme.palette.primary.white,
        cursor: "pointer",
        borderRadius: "4px",
        "&:hover": { backgroundColor: "rgba(23,38,100,0.06)" },
      }}
      onClick={() => onPlay?.(view)}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: "6px", p: "4px" }}>
        <GridViewOutlinedIcon sx={{ fontSize: 24, color: theme.palette.primary.main }} />
        <Typography sx={{ fontSize: 14, fontWeight: 600, color: theme.palette.primary.main }}>
          {view.name}
        </Typography>
      </Box>

      <Box sx={{ display: "flex", alignItems: "center" }}>
        <IconButton
          size="small"
          onClick={(e) => {
            e.stopPropagation();
            onEdit(view);
          }}
          sx={{ p: "4px", color: theme.palette.primary.main }}
        >
          <SettingsIcon width={16} height={16} />
        </IconButton>
        <IconButton
          size="small"
          onClick={(e) => {
            e.stopPropagation();
            onPlay?.(view);
          }}
          sx={{
            p: "4px",
            borderRadius: "50%",
            transition: "all 0.2s",
            color: theme.palette.primary.main,
            "&:hover": {
              backgroundColor: "rgba(23,38,100,0.08)",
            },
          }}
        >
          <StartIcon width={20} height={20} />
        </IconButton>
      </Box>
    </Box>
  );
};

export default ViewItem;
